// @flow
import guayaquilSrc from './bank-guayaquil.svg';
import pichinchaSrc from './bank-pichincha.svg';

export function getSafetypayOnlineImageSrc(bankName: string): string {
  switch (bankName) {
    case 'guayaquil':
      return guayaquilSrc;
    case 'pichincha':
      return pichinchaSrc;
    default:
      throw new Error(`Bank ${bankName} not found`);
  }
}
